import React from 'react';
import { t } from 'Src/i18n';
import type { ServiceMutationType } from 'Utils/graphql-query-helper/booking/proposal/proposalQuery';
import 'Utils/graphql-query-helper/booking/proposal/proposalQuery';
import { useDisclosure } from 'Src/hooks/use-disclosure/useDisclosure';
import { Modal } from 'Components/frameworks/modal/Modal';
import type { ReservationBlockProps } from './ReservationBlock';
import { ReservationBlock } from './ReservationBlock';
type Props = ReservationBlockProps & {
  onClose: () => void;
  onSubmit: (
    arg0: ServiceMutationType,
    arg1: ReadonlyArray<string>,
    arg2: ReadonlyArray<string>,
  ) => Promise<any>;
};
export const PopInReservationBlock = ({
  onClose,
  onSubmit,
  attendeeId,
  showOnlyCurrentAttendeeSlots = false,
  ...otherProps
}: Props) => {
  const {
    isOpen: isButtonLoading,
    onClose: setButtonNotLoading,
    onOpen: setButtonLoading,
  } = useDisclosure();
  return (
    <Modal
      ariaLabel={otherProps.headerLabel}
      closeLabel={t('common.close')}
      onClose={onClose}
      size="small"
    >
      <ReservationBlock
        {...otherProps}
        attendeeId={attendeeId}
        showOnlyCurrentAttendeeSlots={showOnlyCurrentAttendeeSlots}
        onSubmit={async (service, serviceIds, attendeeIds) => {
          if (service) {
            setButtonLoading();
            await onSubmit(service, serviceIds, attendeeIds);
            setButtonNotLoading();
          }

          onClose();
        }}
        isButtonLoading={isButtonLoading}
      />
    </Modal>
  );
};
